import { AISummaryServiceApi } from 'api/AISummaryServiceApi';
import { aiSummaryClient } from 'container/aiSummaryClient';

export const aiSummaryServiceApi = new AISummaryServiceApi(aiSummaryClient);
